module.exports = __webpack_public_path__ + "img/p2-1-1.549632a4.png";